import axios from "axios";
import {
  storeLoginData,
  getLoginData,
  removeLoginData,
  isLoggedIn,
} from "../utils/loginSession";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_NEW,
  headers: {},
});

export const uploadImage = async (endpoint, imageUri) => {
  const formData = new FormData();
  formData.append("file", {
    uri: imageUri,
    name: "photo.jpg", // or any name for the file
    type: "image/jpeg", // or the correct MIME type
  });

  try {
    const response = await api.post(endpoint, formData);
    return response.data;
  } catch (error) {
    console.error("Upload error:", error);
    throw error;
  }
};

export const post = async (endpoint, data, imageData = []) => {
  try {
    // console.log(endpoint, data)
    const token = getLoginData()?.token;

    let headers = {};
    if (token) {
      headers = { Authorization: `Bearer ${token}` };
    }
    const response = await api.post(
      endpoint,
      data,

      {
        headers: headers,
      }
    );
    return response.data.data;
  } catch (error) {
    // console.log("Error Message", error.response)
    if (error.response) {
      throw {
        success: false,
        message: error.response.data.message || "Something went wrong!",
      };
    } else {
      throw { success: false, message: "Network error. Please try again." };
    }
  }
};

export const postWithImage = async (endpoint, data) => {
  try {
    const response = await api.post(endpoint, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    // console.log(`Error is ${error}`)
    if (error.response) {
      // Server responded with a status code not in the 2xx range
      console.error("Error Response Status:", error.response.status);
      console.error(
        "Error Message:",
        error.response.data.error || "Something went wrong"
      );
      throw error.response.data.error;
    } else {
      throw error;
    }
  }
};

export const get = async (endpoint) => {
  try {
    const token = getLoginData()?.token;
    let headers = {};
    if (token) {
      headers = { Authorization: `Bearer ${token}` };
    }
    const response = await api.get(endpoint, {
      headers: headers,
    });
    return response.data.data;
  } catch (error) {
    console.error("API call error:", error);
    throw error;
  }
};
